// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kq-1";
export var messageSideRight = "_kq-2";
export var subscribeToBackInStockBubbleContainer = "_kq-0";